import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils';

const toggleVariants = cva(
  'inline-flex items-center justify-center cursor-pointer',
  {
    variants: {
      variant: {
        default:
          'bg-transparent rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-primary',
        outline:
          'border border-input bg-transparent hover:bg-accent hover:text-primary  disabled:cursor-not-allowed',
        chip: 'w-full border-[1.5px] border-border rounded-full data-[state=on]:border-none hover:bg-muted data-[state=on]:font-semibold data-[state=on]:text-white text-primary justify-start text-xs disabled:opacity-50 disabled:cursor-not-allowed',
      },
      size: {
        default: 'h-10 px-3',
        sm: 'h-9 px-2.5',
        lg: 'h-11 px-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
